<template>
  <div>
    <b-form @submit.prevent.stop="validForm">
      <div class="row">
        <b-form-group class="col-4"
          id="input-group-1"
          label="Nome"
          label-for="input-1"
        >
          <b-form-input
            id="input-2"
            v-model="usuario.nome"
            :class="{
              'is-invalid': formsubmit && $v.usuario.nome.$error,
            }"
            type=""
            
          ></b-form-input>
        </b-form-group>
        <b-form-group class="col-4" id="input-group-2" label="E-mail" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="usuario.email"
            :class="{
              'is-invalid': formsubmit && $v.usuario.email.$error,
            }"
            type=""
            
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group class="col-4" id="input-group-2" label="Senha" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="usuario.senha"
            :class="{
              'is-invalid': formsubmit && $v.usuario.senha.$error,
            }"
            type="password"
            
          ></b-form-input>
        </b-form-group>
      </div>
      <b-button type="submit" variant="primary">Salvar</b-button>
    </b-form>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  mixins: [alertMixin],
  props: {
    usuario: {
      type: Object,
      require: true,
    },
    salvar: {
      type: Function,
    },
    formsubmit: {
      type: Boolean
    },
  },
  data() {
    return {
      produtos: [],
    }
  },
  validations: {
    usuario: {
      nome: { required },
      email: { required },
      senha: { required },
    },
  },
  methods: {
    invalidForm() {
      this.errorMessage('Há campos que não foram preenchidos')
      this.formsubmit = true
    },
    validForm() {
      this.$v.$touch()
      !this.$v.usuario.$error
        ? this.salvar()
        : this.invalidForm()
    },
  },
}
</script>
